module.exports = __webpack_public_path__ + "static/media/nft2.6c03f51b.png";